import React, { useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DropDownButton from "devextreme-react/drop-down-button";
import List from "devextreme-react/list";
import { useAuth } from "../../contexts/auth";
import "./UserPanel.scss";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useFetch } from "@hooks/useAuthApi";
// import { authApi } from "utils/apiClients";
import authApi from "../../api/authApi";

export default function UserPanel({ menuMode }) {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: userDetails, refetch } = useFetch(
    "getUserDetails",
    authApi.getUserDetails
  );

  const navigateToProfile = useCallback(() => {
    navigate("/profile");
  }, [navigate]);

  const handleLogout = useCallback(() => {
    dispatch(logout());
    // navigate("/login");
  }, [dispatch]);

  const menuItems = useMemo(
    () => [
      {
        text: "Profile",
        icon: "user-icon",
        onClick: navigateToProfile,
      },
      {
        text: "Log out",
        icon: "logout-icon",
        onClick: handleLogout,
      },
    ],
    [navigateToProfile, signOut]
  );


  const renderItem = (item) => (
    <div
      className="flex items-center gap-2 text-base"
      title="" // Ensure no tooltip is displayed
    >
      {item.text === "Log out" ? (
        <i className="ri-logout-circle-r-line"></i>
      ) : (
        <i className="ri-user-line"></i>
      )}
      <span>{item.text}</span>
    </div>
  );
  const dropDownButtonAttributes = {
    class: "user-button",
  };

  const buttonDropDownOptions = {
    width: "150px",
  };


  return (
    <div className="user-panel">
      {menuMode === "context" && (
        <DropDownButton
          stylingMode="text"
          icon={
            userDetails?.data?.imageURL
              ? userDetails?.data?.imageURL
              : "/images/user-dummy.png"
          }
          showArrowIcon={false}
          elementAttr={dropDownButtonAttributes}
          dropDownOptions={buttonDropDownOptions}
          items={menuItems}
          itemRender={renderItem}
          onItemClick={(e) => e.itemData.onClick()}
        />
      )}
      {menuMode === "list" && <List items={menuItems} />}
    </div>
  );
}
